<template>
  <div class="i-post-modal">
    <p class="i-post-modal__text">
      {{ messages.iPostDescription }}
    </p>
    <!--        <DefMessageSuccess>-->
    <!--            Ваша адреса потрапляє в зону доставки-->
    <!--        </DefMessageSuccess>-->
    <!--        <DefMessageError>-->
    <!--            Нажаль, ваша адреса не потрапляэ в зону доставки-->
    <!--        </DefMessageError>-->
    <form id="i-post-form" action="" class="i-post-form" @submit.prevent="handlerSubmit">
      <!--            <input name="deliveryId" value="8" type="hidden">-->
      <input name="productId" :value="id" type="hidden" />
      <input name="action" value="createIPostOrder" type="hidden" />
      <!--            <input name="quantity" :value="product" type="hidden">-->
      <DefSelectWrapper
        class="i-post-form__full"
        name="city"
        :value="activeCityName"
        :required="true"
      >
        <template #header>
          {{ activeCityName }}
        </template>
        <template #placeholder>
          <span>{{ messages.city }}</span>
        </template>
        <div
          v-for="city in getIPostCities"
          v-if="getIPostCities.length > 1"
          :key="city.UF_XML_ID"
          @click="changeCurrentCityId(city.ID)"
        >
          {{ city.UF_NAME }}
        </div>
      </DefSelectWrapper>
      <DefInput
        name="street"
        required
        :placeholder="messages.street"
        class="i-post-form__full"
        @blur="IPostFields.STREET = $event.target.value"
      />
      <DefInput
        name="house"
        :placeholder="messages.house"
        required
        @blur="IPostFields.HOUSE = $event.target.value"
      />
      <DefInput
        name="apartment"
        :placeholder="messages.apartment"
        required
        @blur="IPostFields.APARTMENT = $event.target.value"
      />
    </form>
    <h6 class="i-post-modal-title">
      <span>{{ messages.jewelry }}</span>
    </h6>
    <ProductModal :result="product" :messages="messages" />
    <!--        <DefButtonSecondary :disabled="true">-->
    <!--            <DefProgramMe tag="span">Оформити замовлення</DefProgramMe>-->
    <!--        </DefButtonSecondary>-->
    <!--        <br>-->
    <DefButtonPrimary type="submit" form="i-post-form">
      <span>{{ messages.createOrder.title }}</span>
    </DefButtonPrimary>
  </div>
</template>

<script setup>
import { defineProps, reactive, computed, onMounted } from 'vue';
import { useStore } from '@store';
import DefSelectWrapper from '@components/Def/DefSelect/DefSelectWrapper.vue';
import DefInput from '@components/Def/DefInput/DefInput.vue';
import ProductModal from '@components/Product/ProductModal.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';

const { product, messages } = defineProps(['product', 'messages']);
const { state, getters, dispatch, commit } = useStore();

// getters
const id = computed(() => getters['product/id']);
const activeCityName = computed(() => getters['stores/getActiveCityName']);
const getActiveCity = computed(() => getters['stores/getActiveCity']);
const currentCityId = computed(() => getters['stores/getCurrentCityId']);

// state
const getIPostCities = computed(() => cities.filter((el) => el.UF_IPOST_DELIVERY == 1));
const cities = state?.stores?.data?.cities;

const userCities = computed(() => state?.cities?.data);
const userCity = reactive(userCities.value?.userCity);

const IPostFields = reactive({
  STREET: '',
  HOUSE: '',
  APARTMENT: '',
  CITY: getActiveCity,
  CITY_ID: currentCityId,
});
const changeCurrentCityId = (id) => commit('stores/changeCurrentCityId', id);
// const defaultCityId = computed(() => state?.stores?.data?.defaultCityId);

// handlers
const handlerSubmit = async ({ target }) => {
  try {
    commit('global/loaderStart');
    const formData = new FormData(target);

    const { status, data: responseData } = await axios.post('/ajax/', formData);

    if (status !== 200) throw `Bad request response status ${status}`;

    if (responseData.status && responseData.pathToCheckout) {
      commit('global/loaderStop');

      window.sessionStorage.setItem('IPostFields', JSON.stringify(IPostFields));

      location.href = responseData.pathToCheckout;
    }
  } catch (err) {
    console.error(err);
  }
};
onMounted(() => {
  const firstCity = getIPostCities?.value?.filter((el) => el.UF_IPOST_DELIVERY == 1)[0];
  const coincidentCity = getIPostCities?.value?.find((el) => el.ID == userCity.ID);
  coincidentCity ? changeCurrentCityId(coincidentCity?.ID) : changeCurrentCityId(firstCity?.ID);
});
// const id = computed(() => {
//     return product?.value?.offer?.id || product.value?.id;
// });
</script>

<script>
export default {
  name: 'IPostModal',
};
</script>

<style lang="scss" scoped>
.i-post-modal {
  &__text {
    margin-bottom: 24px;
    font-weight: 500;
    font-size: rem(14);
    line-height: 125%;
    color: var(--color-dark-grey);
  }
  :deep(.def-button-secondary),
  :deep(.def-button-primary) {
    width: 100%;
    @include point-md {
      max-width: 280px;
    }
  }
  :deep(.product-modal) {
    margin-bottom: 32px;
  }
  :deep(.def-message-success),
  :deep(.def-message-error) {
    margin-bottom: 24px;
  }
}
.i-post-form {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-row-gap: 10px;
  grid-column-gap: 20px;
  max-width: 480px;
  margin-bottom: 18px;
  &__full {
    grid-column-start: 1;
    grid-column-end: 3;
  }
  :deep(.def-select-wrapper) {
    margin-bottom: 14px;
  }
}
.i-post-modal-title {
  font-weight: 500;
  font-size: rem(16);
  line-height: 130%;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin: 24px 0 16px;
  @include point-md {
    margin: 40px 0 24px;
  }
}
</style>
